import { t } from "../i18n"
import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="autosize"
export default class extends Controller {
  connect() {
    this.autosize()
    this.element.addEventListener('input', () => this.autosize())
  }

  autosize() {
    this.element.style.height = 'auto'
    this.element.style.height = this.element.scrollHeight + 'px'
  }

  submitOnEnter(event) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault()
      this.element.form.requestSubmit()
    }
  }
}
